import { LooseObject } from '../types'
const lsData: LooseObject = {}
const ssData: LooseObject = {}
let hasLocalStorage = false
let hasSessionStorage = false
const ls = window.localStorage
const ss = window.sessionStorage

if (ls) {
  try {
    const x = 'storageTest'
    ls.setItem(x, x)
    ls.removeItem(x)
    hasLocalStorage = true
  } catch (e) {
    hasLocalStorage = false
  }
}
if (ss) {
  try {
    const x = 'storageTest'
    ss.setItem(x, x)
    ss.removeItem(x)
    hasSessionStorage = true
  } catch (e) {
    hasSessionStorage = false
  }
}

class LStorageUtilities {
  setItem(key: string, value: any) {
    if (hasLocalStorage) {
      ls.setItem(key, value)
    } else {
      lsData[key] = value
    }
  }

  getItem(key: string) {
    if (hasLocalStorage) {
      return ls.getItem(key)
    }
    return lsData[key]
  }

  removeItem(key: string) {
    if (hasLocalStorage) {
      ls.removeItem(key)
    } else {
      lsData[key] = null
    }
  }
}

class SStorageUtilities {
  setItem(key: string, value: any) {
    if (hasLocalStorage) {
      ss.setItem(key, value)
    } else {
      ssData[key] = value
    }
  }

  getItem(key: string) {
    if (hasLocalStorage) {
      return ss.getItem(key)
    }
    return ssData[key]
  }

  removeItem(key: string) {
    if (hasLocalStorage) {
      ss.removeItem(key)
    } else {
      ssData[key] = null
    }
  }
}

// const safeLs = new LStorageUtilities()
const safeSs = new SStorageUtilities()

export function getQS() {
  const token = safeSs.getItem('payToken') ?? ''
  const qs = JSON.parse(safeSs.getItem('qs') ?? '{}')
  return qs[token] ?? {}
}

export function setQS(val: any) {
  const token = val.payToken
  if (!token) return
  safeSs.setItem('payToken', token)
  const cache = safeSs.getItem('qs') ?? '{}'
  const qs = JSON.parse(cache) ?? {}
  qs[token] = val
  return safeSs.setItem('qs', JSON.stringify(qs))
}

export function getEvokePolicy() {
  const res = safeSs.getItem('EVOKE_POLICY') || '{}'
  return JSON.parse(res)
}

export function setEvokePolicy(val = {}) {
  return safeSs.setItem('EVOKE_POLICY', JSON.stringify(val))
}
